import * as Sentry from '@sentry/browser'

const sentryData = document.head.querySelector('meta[name="app-data"]').dataset

if (sentryData.sentryDsn) {
  Sentry.init({
    dsn: sentryData.sentryDsn,
    release: sentryData.sentryRelease,
    environment: sentryData.sentryEnv,
    dataCollection: {
      userInfo: false,
      httpBodies: []
    },
    integrations: [
      Sentry.thirdPartyErrorFilterIntegration({
        filterKeys: ['alveos-sentry'],
        behaviour: "drop-error-if-contains-third-party-frames",
      }),
    ],
  })

  Sentry.setUser({ id: sentryData.userId })
}
